export enum CAMINO_MEMBER_IMPORT_STATUS {
  PENDING = 'pending',
  PROCESSING = 'processing',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export const CAMINO_MEMBER_IMPORT_IN_PROGRESS_STATUSES: CAMINO_MEMBER_IMPORT_STATUS[] = [
  CAMINO_MEMBER_IMPORT_STATUS.PENDING,
  CAMINO_MEMBER_IMPORT_STATUS.PROCESSING,
];

export const CAMINO_MEMBER_IMPORT_STATUS_LABELS: Record<CAMINO_MEMBER_IMPORT_STATUS, string> = {
  [CAMINO_MEMBER_IMPORT_STATUS.PENDING]: 'Pending',
  [CAMINO_MEMBER_IMPORT_STATUS.PROCESSING]: 'Processing',
  [CAMINO_MEMBER_IMPORT_STATUS.COMPLETED]: 'Completed',
  [CAMINO_MEMBER_IMPORT_STATUS.FAILED]: 'Failed',
};

export const isCaminoMemberImportInProgress = (status: CAMINO_MEMBER_IMPORT_STATUS): boolean =>
  CAMINO_MEMBER_IMPORT_IN_PROGRESS_STATUSES.includes(status);

export type CaminoMemberImportRun = {
  id: string;
  status: CAMINO_MEMBER_IMPORT_STATUS;
  createdAt: string;
  hasReport: boolean;
};
